import dayjs from "dayjs"
import { DATE_FORMAT } from "src/utils/constants"

const DECIMAL_LIMIT_MESSAGE = "Informe no máximo 22 dígitos inteiros e 8 casas decimais."
const DECIMAL_FORMAT_MESSAGE = "Informe um número decimal válido."
const DECIMAL_INCOMPLETE_MESSAGE = "Conclua o valor ou limpe o campo."
const GENERIC_CALCULATION_ERROR_MESSAGE = "Erro no cálculo, entre em contato com suporte@c2ps.com.br."
const DECIMAL_PATTERN = /^-?\d{1,22}(?:[,.]\d{1,8})?$/
const INCOMPLETE_DECIMAL_PATTERN = /^-?(?:\d+)?[,.]$/

export const getPreviousWeekdayReferenceDate = (now = new Date()) => {
    const referenceDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
    )

    referenceDate.setDate(referenceDate.getDate() - 1)

    while (referenceDate.getDay() === 0 || referenceDate.getDay() === 6) {
        referenceDate.setDate(referenceDate.getDate() - 1)
    }

    return dayjs(referenceDate).format(DATE_FORMAT)
}

export const getDecimalValidationMessage = (value) => {
    const decimalValue = String(value ?? "")

    if (decimalValue === "") {
        return ""
    }

    if (decimalValue === "-" || INCOMPLETE_DECIMAL_PATTERN.test(decimalValue)) {
        return DECIMAL_INCOMPLETE_MESSAGE
    }

    if (!DECIMAL_PATTERN.test(decimalValue)) {
        const [integerPart, decimalPart] = decimalValue.replace(/^-/, "").split(/[,.]/)

        if (integerPart.length > 22 || decimalPart?.length > 8) {
            return DECIMAL_LIMIT_MESSAGE
        }

        return DECIMAL_FORMAT_MESSAGE
    }

    return ""
}

const isCompleteOptionalDecimal = (value) => !getDecimalValidationMessage(value)

export const isValidationParametersReady = ({
    dataReferencia,
    puparReferencia,
    pumtmReferencia,
    spreadCredito,
} = {}) => (
    Boolean(dataReferencia)
    && isCompleteOptionalDecimal(puparReferencia)
    && isCompleteOptionalDecimal(pumtmReferencia)
    && isCompleteOptionalDecimal(spreadCredito)
)

export const getValidationErrorMessage = (
    isAdminUser,
    calculationErrorCode,
    authorizedMessagesByCode
) => (
    isAdminUser && calculationErrorCode
        ? authorizedMessagesByCode?.[calculationErrorCode] || GENERIC_CALCULATION_ERROR_MESSAGE
        : GENERIC_CALCULATION_ERROR_MESSAGE
)
